import { KioskNavigation } from "../../../models/KioskNavigations";

export const navigation: KioskNavigation[] = [
  {
    id: "increasemoney",
    title: "increaseMoney",
    width: "24px",
    height: "24px",
    translate: "Increase Credit",
    url: "/user/portfolio",
    type: "item",
    icon: "addmoneysidebar",
    specialBgColor: "bgPrimary",
  },
  {
    id: "dashboard",
    title: "dashboard",
    width: "20px",
    height: "20px",
    translate: "Dashboard",
    url: "/",
    type: "item",
    icon: "dashboard",
  },
  {
    id: "wallet",
    title: "wallet",
    width: "20px",
    height: "20px",
    translate: "Wallet",
    url: "/user/portfolio",
    type: "item",
    icon: "wallet",
  },
  {
    id: "coin-withdraw",
    title: "coinWithdraw",
    width: "20px",
    height: "20px",
    translate: "Withdraw Coin",
    url: "/coin/withdraw",
    type: "item",
    icon: "coinWithDraw",
  },
  {
    id: "collateral-page",
    title: "coinWithdraw",
    width: "20px",
    height: "20px",
    translate: "Collateral",
    url: "/collateral",
    type: "item",
    icon: "shieldDone",
  },
  {
    id: "easy",
    title: "easy",
    width: "20px",
    height: "20px",
    translate: "Easy order",
    url: "/crypto/trade/easy",
    type: "item",
    icon: "easytradeoff",
  },
  // {
  //   id: 'markets',
  //   title: 'markets',
  //   width: '20px',
  //   height: '20px',
  //   translate: 'NAVMARKET',
  //   url: '/markets',
  //   type: 'item',
  //   icon: 'markets',
  // },
  // {
  //   id: "markets",
  //   title: "markets",
  //   width: "20px",
  //   height: "20px",
  //   url: "/markets",
  //   translate: "NAVMARKET",
  //   // type: "collapsable",
  //   type: "item",
  //   icon: "markets",
  // },
  // {
  //   id: 'charts',
  //   title: 'Charts',
  //   width: '24px',
  //   height: '23.6px',
  //   translate: 'NAVMARKETS',
  //   url: '/markets',
  //   type: 'item',
  //   icon: 'markets',
  // },

  {
    id: "charts",
    title: "Charts",
    width: "20px",
    height: "20px",
    translate: "History",
    url: "/crypto/trade/history",
    type: "item",
    icon: "history",
  },
  // {
  //   id: "profile",
  //   title: "Profile",
  //   width: "20px",
  //   height: "20px",
  //   translate: "NAVPROFILE",
  //   url: "/setting",
  //   type: "item",
  //   icon: "sidprofile",
  // },
  // {
  //   id: "invite",
  //   title: "Invite",
  //   width: "23px",
  //   height: "26.3px",
  //   translate: "NAVINVITE",
  //   url: "/user/invite",
  //   type: "item",
  //   icon: "inviteUser",
  // },
  {
    id: "referral",
    title: "Referral",
    width: "23px",
    height: "26.3px",
    translate: "Invitation",
    url: "/referral",
    type: "item",
    icon: "inviteUser",
  },
  {
    id: "setting",
    title: "Setting",
    width: "23px",
    height: "26.3px",
    translate: "Setting",
    url: "/setting",
    type: "item",
    icon: "setting",
  },

  // {
  //     id       : 'favorite',
  //     title    : 'Favorite',
  //     width    : '23px',
  //     height   : '20.6px',
  //     translate: 'NAVFAVORITE',
  //     url      : '/',
  //     type     : 'item',
  //     icon     : 'sideheart',
  // },
];
